import React,{ Fragment } from 'react'
import { Box } from '@chakra-ui/react';
import AllDispute from '../../component/AllDispute';

const DisputeAll = () => {
  return (
    <Fragment>
        <Box p={5} flex="1" w={'100%'}>
            <AllDispute
            title={'All Disputes'}
            head={["Dispute ID", "Email ID", "Dipute Type", "Dispute Status",""]}
            data={[{dispute_id: "#178987", email_id: "sheela@xyz.com", dispute_type: "Settlement", dispute_status: "In Progress"},{dispute_id: "#178987", email_id: "sheela@xyz.com", dispute_type: "General Query", dispute_status: "Resolved"},{dispute_id: "#178987", email_id: "sheela@xyz.com", dispute_type: "Return", dispute_status: "Canceled"},{dispute_id: "#178987", email_id: "sheela@xyz.com", dispute_type: "Settlement", dispute_status: "Closed"},{dispute_id: "#178987", email_id: "sheela@xyz.com", dispute_type: "General Query", dispute_status: "Closed"}]}/>
        </Box>
    </Fragment>
  )
}

export default DisputeAll